// utils/adFieldConstants.js

/**
 * 广告可选择的字段列表
 */
export const AD_FIELDS = [
    { key: 'smart_plus_ad_id', label: '广告ID', default: true },
    { key: 'ad_name', label: '广告名称', default: true },
    // { key: 'ad_format', label: '广告格式', default: true },
    { key: 'creative_preview', label: '创意预览', default: true },
    { key: 'review_status', label: '审核状态', default: true },
    { key: 'operation_status', label: '状态', default: true },
    { key: 'create_time', label: '创建时间', default: true },
    { key: 'modify_time', label: '修改时间', default: false },
    { key: 'ad_text', label: '广告文案', default: false },
    { key: 'call_to_action', label: '行动号召', default: false },
    { key: 'landing_page_url', label: '落地页URL', default: false },
    { key: 'deeplink', label: '应用落地页', default: false }
]

/**
 * 字段显示名称映射
 */
export const AD_FIELD_LABEL = {
    smart_plus_ad_id: '广告ID',
    ad_name: '广告名称',
    ad_format: '广告格式',
    creative_preview: '创意预览',
    review_status: '审核状态',
    operation_status: '状态',
    create_time: '创建时间',
    modify_time: '修改时间',
    ad_text: '广告文案',
    call_to_action: '行动号召',
    landing_page_url: '落地页URL',
    deeplink: '应用落地页'
}